import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

const InvitePage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const verifyToken = async () => {
      try {
        const response = await fetch(`/api/invites/verify/${token}`);
        const data = await response.json();

        if (data.success) {
          setStatus("valid");
          setMessage(`Invite is valid! Group: ${data.invite.group_name}`);

          // Redirect to signup page with invite token after 2 seconds
          setTimeout(() => {
            navigate(`/signup?inviteToken=${token}`);
          }, 2000);
        } else {
          setStatus("invalid");
          setMessage(data.message);
        }
      } catch (err) {
        console.error("Error verifying invite:", err);
        setStatus("error");
        setMessage("Server error while verifying invite.");
      }
    };

    verifyToken();
  }, [token, navigate]);

  return (
    <div style={{ padding: "2rem" }}>
      <h2>Group Invitation</h2>
      {status === "loading" && <p>Verifying invite token...</p>}
       {status === "valid" && (
  <div>
    <p>{message}</p>
    <a href={`/signup?inviteToken=${token}`}>Click here to create an account</a>
  </div>
)}

      {(status === "invalid" || status === "error") && (
        <p style={{ color: "red" }}>{message}</p>
      )}
    </div>
  );
};

export default InvitePage;
